/**
 * i18n hooks: a tiny t() over a message catalog. English only for now; a locale from PRISM's host:init (M5) picks
 * another catalog when one exists. Messages use {name} placeholders.
 */
import { en } from './messages.en.ts';

export type Messages = Record<string, string>;

const catalogs: Record<string, Messages> = { en };
let current: Messages = en;
let currentLocale = 'en';

export function setLocale(locale: string): void {
  const lang = locale.toLowerCase().split(/[-_]/)[0] ?? 'en';
  current = catalogs[lang] ?? en;
  currentLocale = catalogs[lang] ? lang : 'en';
}

export function locale(): string {
  return currentLocale;
}

export function t(key: string, params?: Record<string, string | number | undefined>): string {
  const msg = current[key] ?? en[key] ?? key;
  if (!params) return msg;
  return msg.replace(/\{(\w+)\}/g, (m, k: string) => (params[k] === undefined ? m : String(params[k])));
}

/** Format a byte count for people. */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} kB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
